<template>
  <div class="copyright">
    <p>
      Original design by RHP Team - Developed by
      <a href="https://www.facebook.com/tam.tran.136" target="_blank"
        >Tran Tam</a
      >
    </p>
  </div>
</template>

<style lang="css" scoped>
.copyright {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  bottom: 1rem;
  color: var(--light);
  z-index: 3;
  font-size: 1.2rem;
  text-align: center;
}
.copyright a {
  color: #f4dc26;
}
</style>